import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PageLoader from 'shared/components/PageLoader';

import { usePartnerAuth } from '../context/PartnerAuthContext';

const PartnerProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = usePartnerAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default PartnerProtectedRoute;
